import { getStore } from '@/store'
import debug from 'debug'
import { actionCreators } from '@/store/Identity'
import moment from 'moment'
import { crossTabAction } from '@/utils/crossTabAction'

const log = debug('app:auth')

function initAuth () {
  log('auth startup')
  getStore().dispatch(actionCreators.loadUser())
}

let monitorHandle = 0
function startJwtMonitor () {
  if (monitorHandle) clearInterval(monitorHandle)
  monitorHandle = setInterval(checkJwt, 15000)
}

function checkJwt () {
  const user = getUserProfile()
  if (user && user.exp) {
    const expiresAt = moment(user.exp * 1000)
    const shouldRefresh = expiresAt.isBefore(moment().add(1, 'minute'))
    if (shouldRefresh) {
      crossTabAction(() => {
        log('refreshing token...')
        getStore().dispatch(actionCreators.silentRefresh())
      })
    }
  }
}

function getUserProfile () {
  const identity = getStore().getState().identity
  if (identity && identity.user) {
    return identity.user.profile
  }
  return null
}

export {
  initAuth,
  startJwtMonitor
}



// WEBPACK FOOTER //
// ./src/utils/auth.js